import React, { HTMLAttributes } from 'react'

import { NavMenuContentType } from '@hhgtech/hhg-components/components/navigationV2/index'

import { NavigatorLayout } from 'components/templates/navigatorLayout'
import { ExpertUser, FooterInfo } from 'interfaces/types'
import { useExpertStore } from 'state/expert'

import _Author from './author'
import _Expert from './expert'

interface WithExpertTemplateProps extends HTMLAttributes<HTMLDivElement> {
  expert: ExpertUser
  isMobileSsr: boolean
  footerInfo?: FooterInfo
  dataNavMenuContent?: NavMenuContentType
}
export interface ExpertTemplateProps extends WithExpertTemplateProps {
  expert: ExpertUser

  isMobileSsr: boolean
  footerInfo?: FooterInfo
  dataNavMenuContent?: NavMenuContentType
}

export function withExpertTemplate<
  T extends WithExpertTemplateProps = WithExpertTemplateProps
>(WrappedComponent: React.ComponentType<T>) {
  // Try to create a nice displayName for React Dev Tools.
  const displayName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component'

  // Creating the inner component. The calculated Props type here is the where the magic happens.
  const ComponentWithExpertTemplate = ({
    footerInfo,
    dataNavMenuContent,
    ...rest
  }: ExpertTemplateProps) => {
    const { currentExpert: expert } = useExpertStore((state) => ({
      currentExpert: state.currentExpert,
    }))
    return (
      <NavigatorLayout
        SEOData={{
          apiMetaData: expert?.metaTag,
          isIndexable: true,
        }}
        type="profile"
        footerInfo={footerInfo}
        dataNavMenuContent={dataNavMenuContent}
      >
        <WrappedComponent {...(rest as T)} />
      </NavigatorLayout>
    )
  }

  ComponentWithExpertTemplate.displayName = `withExpertTemplate(${displayName})`

  return ComponentWithExpertTemplate
}

export const ExpertTemplate = React.memo(withExpertTemplate(_Expert))
export const AuthorTemplate = React.memo(withExpertTemplate(_Author))
